import { isExternalListing } from "@anaconda/core/nft/listing-source"
import type { NftMiniature } from "@anaconda/core/nft/types"
import { Platform } from "@rarible/api-client"
import { cn } from "@rarible_int/anaconda_ui_components"
import Image from "next/image"

/**
 * Only our own listings get an icon. Aggregated listings carry a
 * listingSource; Union-served orders from other marketplaces (e.g. OpenSea
 * Seaport) carry only the order platform.
 */
function isRaribleListing(
  listingSource: NftMiniature["listingSource"],
  platform: Platform | undefined,
) {
  return (
    !isExternalListing(listingSource) &&
    (!platform || platform === Platform.RARIBLE)
  )
}

export function ListingSourceBadge({
  listingSource,
  platform,
  className,
}: {
  listingSource: NftMiniature["listingSource"]
  platform?: Platform
  className?: string
}) {
  if (!isRaribleListing(listingSource, platform)) return null

  return (
    <Image
      src="/rarible.svg"
      alt="Rarible"
      width={14}
      height={14}
      className={cn("inline-block", className)}
    />
  )
}
